import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { finalize } from 'rxjs/operators'

import { ResultCode } from '../../../domain/authentication.model'
import { AuthService } from '../../../services/auth.service'
import { NotificationService } from '../../../services/notification.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-update-password-form',
  templateUrl: './bmcore-update-password-form.component.html',
  styleUrls: ['./bmcore-update-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreUpdatePasswordFormComponent implements OnInit {
  lg: LgType
  updatePasswordForm: UntypedFormGroup
  isLoader = false

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private formBuilder: UntypedFormBuilder,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()

    this.updatePasswordForm = this.formBuilder.group({
      currentPassword: [],
      newPassword: [],
      confirmPassword: []
    })
  }

  onSubmit() {
    if (this.updatePasswordForm.valid) {
      const { currentPassword, newPassword, confirmPassword } = this.updatePasswordForm.value

      if (newPassword.newPassword === confirmPassword.confirmPassword) {
        this.isLoader = true

        this.authService
          .setNewPassword(newPassword.newPassword, currentPassword.currentPassword)
          .pipe(finalize(() => (this.isLoader = false)))
          .subscribe(
            res => {
              if (res.resultCode === ResultCode.Success) {
                this.notificationService.handleSuccess(this.lg.forms.passwordSuccessfullyChanged)
              } else {
                this.notificationService.handleError(res.messages[0])
              }
            },
            err => this.notificationService.handleError(err.message)
          )
      } else {
        this.notificationService.handleError(this.lg.forms.passwordsDontMatch)
      }
    } else {
      this.notificationService.handleError(this.lg.forms.error)
    }
  }
}
